module.exports = __webpack_public_path__ + "img/bg_4.6df82c17.png";